import { render, staticRenderFns } from "./Ingresos.vue?vue&type=template&id=6a4fae00&scoped=true"
import script from "./Ingresos.vue?vue&type=script&lang=js"
export * from "./Ingresos.vue?vue&type=script&lang=js"
import style0 from "./Ingresos.vue?vue&type=style&index=0&id=6a4fae00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4fae00",
  null
  
)

export default component.exports